module.exports = __webpack_public_path__ + "static/media/fit-club.3969b17f.jpg";